import { LANGUAGES_RTL_LIST } from '@/base/const/lang.const'

export const DOCUMENT_DIRECTION = {
  ltr: 'ltr',
  rtl: 'rtl',
}

export function getLangDirection(lang) {
  return LANGUAGES_RTL_LIST.includes(String(lang || '').toUpperCase()) ? DOCUMENT_DIRECTION.rtl : DOCUMENT_DIRECTION.ltr
}
